import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './fifth-wheel-connection.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const FifthWheelConnectionDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const fifthWheelConnectionEntity = useAppSelector(state => state.fifthWheelConnection.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="fifthWheelConnectionDetailsHeading">
          <Translate contentKey="fleetSenseApp.fifthWheelConnection.detail.title">FifthWheelConnection</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{fifthWheelConnectionEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.fifthWheelConnection.created">Created</Translate>
            </span>
          </dt>
          <dd>{fifthWheelConnectionEntity.created ? <TextFormat value={fifthWheelConnectionEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="installVehicleOdometer">
              <Translate contentKey="fleetSenseApp.fifthWheelConnection.installVehicleOdometer">Install Vehicle Odometer</Translate>
            </span>
          </dt>
          <dd>{fifthWheelConnectionEntity.installVehicleOdometer}</dd>
          <dt>
            <span id="installTrailerOdometer">
              <Translate contentKey="fleetSenseApp.fifthWheelConnection.installTrailerOdometer">Install Trailer Odometer</Translate>
            </span>
          </dt>
          <dd>{fifthWheelConnectionEntity.installTrailerOdometer}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelConnection.vehicle">Vehicle</Translate>
          </dt>
          <dd>{fifthWheelConnectionEntity.vehicle ? fifthWheelConnectionEntity.vehicle.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelConnection.trailer">Trailer</Translate>
          </dt>
          <dd>{fifthWheelConnectionEntity.trailer ? fifthWheelConnectionEntity.trailer.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelConnection.company">Company</Translate>
          </dt>
          <dd>{fifthWheelConnectionEntity.company ? fifthWheelConnectionEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.fifthWheelConnection.vehiclePosition">Vehicle Position</Translate>
          </dt>
          <dd>{fifthWheelConnectionEntity.vehiclePosition ? fifthWheelConnectionEntity.vehiclePosition.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/fifth-wheel-connection" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/fifth-wheel-connection/${fifthWheelConnectionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FifthWheelConnectionDetail;
